/**
 * Prefix used for Stuller events
 */
const STULLER_EVENT_PREFIX = 'stuller-'

export {
  STULLER_EVENT_PREFIX
}
